import {
  Entity, PrimaryGeneratedColumn, Column, OneToMany,
} from 'typeorm';
import { IsOptional, IsInt } from 'class-validator';
import { Exame } from './Exame';

@Entity({name: 'grupos_exames'})
export class GrupoExame {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  nome: string;

  @Column()
  ordem: number;

  @OneToMany(type => Exame, exame => exame.grupo_exame_id)
  exames?: Exame[];
}
